<template>
  <div class="cart">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Truck_And_Container') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Truck_Front') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaTruckfront"
          :otherData="{
            mediaName: '货柜前面照',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaTruckfront',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Licence') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaLicence"
          :otherData="{
            mediaName: '车牌',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaLicence',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Container_Side') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaContainerside"
          :otherData="{
            mediaName: '货柜侧面',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaContainerside',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Container_Inside_Check') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaCheck"
          :otherData="{
            mediaName: '货柜前柜内检查',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaCheck',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Container_No_Inside') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaContinside"
          :otherData="{
            mediaName: '货柜内壁柜号',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaContinside',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Container_No_Outside') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaContoutside"
          :otherData="{
            mediaName: '货柜外壁柜号',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaContoutside',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Truck_Badge_Back') }}</span>
      <div class="img">
        <show-img
          :data="cart.lmediaBadgeback"
          :otherData="{
            mediaName: '货柜车尾照',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaBadgeback',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {
    supervisionDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionDetails),
        );
      },
    },
    cart: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionImgList.cart),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {},
  methods: {},
};
</script>
<style lang="less">
.cart {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.reportModal1 {
  .updataForm {
    display: flex;
    .ant-form-item-label {
      text-align: left;
    }
    > div {
      width: 50%;
    }
    .title {
      width: 70%;
      text-align: center;
      margin-top: 5px;
      > button {
        margin-bottom: 3px;
      }
    }
    .part {
      width: 70%;
      padding-top: 10px;
      border-bottom: 1px dashed rgba(25, 21, 37, 0.28);
      display: flex;
      .ant-form-item-label {
        flex-shrink: 0;
      }
      .ant-row {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
